module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/floatingtoolbar_link_font-ec81c3.svg";